import styled from 'styled-components';

export const WrapMedia = styled.div`
  width: 100%;
  ${({ theme }) => theme.spacing.articleBody};

  &:not(:last-child) {
    margin-bottom: 1em;
  }

  & > * {
    width: 100%;
  }
`;

export const WrapImage = styled.div`
  width: 100%;
  position: relative;
  color: ${({ theme }) => theme.colors.grayscale[20]};
  cursor: pointer;

  .wrap-play{
    position: relative;
    width: 100%;
    ${({ theme }) => theme.spacing.articleBody};

    svg {
      width: 100px;
      height: 100px;
      position: absolute;
      top: calc(50% - 220px);
      left: calc(50% - 50px);
      border-radius: 100px;
      border: solid 2px  ${({ theme }) => theme.colors.grayscale[20]};
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;

      @media (max-width: 1480px){
        width: 100px;
        height: 100px;
        padding: 10px;
        top: calc(50% - 260px);
        left: calc(50% - 50px);
      }

      @media (max-width: 1090px){
        width: 100px;
        height: 100px;
        padding: 10px;
        top: calc(50% - 220px);
        left: calc(50% - 50px);
      }

      @media (max-width: 890px){
        width: 100px;
        height: 100px;
        padding: 10px;
        top: calc(50% - 220px);
        left: calc(50% - 50px);
      }

      @media (max-width: 790px){
        width: 80px;
        height: 80px;
        padding: 10px;
        top: calc(50% - 190px);
        left: calc(50% - 40px);
      }

      @media (max-width: 600px){
        width: 50px;
        height: 50px;
        padding: 10px;
        top: calc(50% - 170px);
        left: calc(50% - 25px);
      }
    }
  }
`;
